// extracted by mini-css-extract-plugin
export default {"icon-button-wrapper":"_2d3uh","iconButtonWrapper":"_2d3uh","number":"_1I5ff"};